/*
 * Browser shim for `class-transformer`.
 *
 * WEB imports api/src DTOs for their shapes and values. Those DTOs are decorated with
 * class-transformer (@Type, @Transform, ...), which WEB never executes — it only needs the
 * classes to define their properties. Each decorator is stubbed to a no-op factory so the
 * decorated DTOs still load without pulling class-transformer into the browser bundle.
 *
 * A decorator used by an api DTO but missing here fails the WEB build with
 * "export '<Name>' was not found in 'class-transformer'". Add the stub rather than
 * reworking the DTO.
 */
function noopDecoratorFactory() {
	return function () {};
}

function Type(...args) {
	return noopDecoratorFactory(...args);
}

function Transform(...args) {
	return noopDecoratorFactory(...args);
}

exports.Type = Type;
exports.Transform = Transform;
